export default "/images/droplet.svg?49d3b1343e88b01d4777efaff5589121";